(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["home-slider"] && !window.DesignMode) return;
  try {
    
var swiper = new Swiper('.swiper-container', {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-wholesale-inquiry"]) return;
  try {
    

  // Initialize observers on address selectors
  new Shopify.CountryProvinceSelector('address_country_new', 'address_province_new', {
    hideElement: 'address_province_container_new'
  });



  } catch(e) { console.error(e); }
})();

})();
